<template>
  <div class="tip" v-if="tipVisible">
    <div class="tip_bg"></div>
    <div class="tip_box">
      <div class="tip_colse" @click="colsetip">
        <img
          class="tip_colse_img"
          :src="require('@/img/' + getTheme + '-close.png')"
          alt=""
        />
      </div>
      <div class="tip_title">{{ $t("appTip.title") }}</div>
      <div class="tip_text">{{ $t("appTip.text") }}</div>
      <div class="tip_btn" @click="tip">
        {{ $t("appTip.ok") }}
      </div>
    </div>
  </div>
</template>
<script>
import configs from "@/config/config.js";
export default {
  data() {
    return {
      getTheme: "",
      tipVisible: false,
      targetStartDate: new Date("2023-07-21 17:00:00 GMT+0300"),
      targetEndDate: new Date("2023-07-22 20:00:00 GMT+0300"),
    };
  },
  created() {
    this.getTheme = configs.getTheme();
    const now = new Date().getTime();
    console.log("now", now);
    if (now > this.targetStartDate && now <= this.targetEndDate.getTime()) {
      this.tipVisible = true;
    }
  },
  mounted() {},
  methods: {
    async tip() {
      this.tipVisible = false;
    },
    colsetip() {
      this.tipVisible = false;
    },
  },
};
</script>
<style scoped="scoped">
.tip {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tip_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.tip_box {
  position: relative;
  z-index: 2;
  width: 7.6rem;
  background-color: #fff;
  border-radius: 0.45rem;
}
.tip_colse {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.29rem 0.24rem;
}
.tip_colse_img {
  width: 0.73rem;
  height: 0.73rem;
}
.tip_url {
  position: relative;
  width: 2.18rem;
  height: 2.18rem;
  margin: 0.66rem auto 0;
}
.tip_img {
  box-sizing: border-box;
  object-fit: cover;
  width: 2.18rem;
  height: 2.18rem;
  border-radius: 0.2rem;
  border: 0.06rem solid #ffffff;
  box-shadow: 0px 0.07rem 0.15rem 0px rgba(0, 0, 0, 0.2);
}
.tip_title {
  margin: 0.3rem auto 0;
  width: 80%;
  text-align: center;
  font-size: 0.5rem;
  color: #000;
}
.tip_text {
  margin-top: 0.4rem;
  font-size: 0.4rem;
  color: #1d1d1d;
  padding: 0 0.7rem;
  text-align: center;
}
.tip_btn {
  left: 10%;
  width: 80%;
  height: 1.32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.42rem;
  color: #05080b;
  background-color: #fff34f;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.61rem;
  margin: 0.4rem auto 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/model/tip.vue